<template>
  <v-container>
    <v-row align="center" justify="center">

      <div class="home">
      </div>
    </v-row>
    <v-row justify="center" align="center">
      <v-col cols="4" v-for="apps in tempdata" :key="apps.app_id">
        <v-card :loading="loading" class="mx-auto my-12" max-width="374">
          <template slot="progress">
            <v-progress-linear
              color="deep-purple"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>

          <v-img height="250" :src="apps.image_path"></v-img>

          <v-card-title>{{ apps.app_name }}</v-card-title>

          <v-card-text>
            <div>{{ apps.description }}</div>
          </v-card-text>

          <v-divider class="mx-4"></v-divider>

          <v-card-actions>
            <v-btn
              color="deep-purple lighten-2"
              text
              :loading="isLoading"
              @click="clickonlink(apps.app_url,apps.app_id)"
            >
              Launch
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import VueAxios from "vue-axios";
import apifactory from "../../../apis/apifactory";

Vue.use(VueAxios, axios);
export default {
  name: "ExtraAuth",
  data: () => ({
    userid: null,
    appItems: null,
    appItemsprefered: "",
    isLoading: false,
    msg: "",
    tempdata: [
      {
        user_id: 8,
        key: "2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3",
        app_id: 1,
        app_name: "MMM",
        app_url:
          "/allapps",
        image_path:
          "https://trigma-marketing-mix.s3.ap-south-1.amazonaws.com/mmm2.jpg",
        description: "",
        app_url_withkey:
          "http://trigma-mplatform-uend.s3-website.ap-south-1.amazonaws.com/#/ExtraAuth/?key=2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3&app_id=1&user_id=",
        app_withkey:
          "?user_id=8&key=2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3&app_id=1",
      },
      {
        user_id: 8,
        key: "2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3",
        app_id: 2,
        app_name: "NBX",
        app_url:
          "http://trigma-nbx-uend.s3-website.ap-south-1.amazonaws.com/#/ExtraAuth/?key=2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3&app_id=2&user_id=",
        image_path:
          "https://trigma-marketing-mix.s3.ap-south-1.amazonaws.com/nbx1.jpg",
        description: "",
        app_url_withkey:
          "http://trigma-insightsstory-uend.s3-website.ap-south-1.amazonaws.com/#/ExtraAuth/?user_id=8&key=2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3&app_id=2",
        app_withkey:
          "?user_id=8&key=2c624232cdd221771294dfbb310aca000a0df6ac8b66b696d90ef06fdefb64a3&app_id=2",
      }
    ],
  }),
  computed: {
    appitemfirst() {
      return this.appItems.length;
    },
  },
  mounted() {
    this.getstoragevalues();
    this.getloginuserapp();
  },
  methods: {
    checkauth() {
      this.getauthdata();
      this.loginusername = "";

      //this.loginusernametbd = localStorage.getItem('SET_USERID');
      // this.$router.push("/configuration/brand");
      //this.goTo("/configuration/brand");
    },
    getstoragevalues() {
      this.userid = localStorage.getItem("SET_USERID");
    },
    getloginuserapp() {
      apifactory
        .getloginuserapps(this.userid)
        .then((res) => {
           //alert(res);

          if (res.status != 200) {
            alert(res.data.message);
          } else {
            this.appItems = res.data;
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
clickonlink(varurl,app_id) {
    this.isLoading = true
    this.getstoragevalues();
        if (app_id ==1) { 
          this.goTo(varurl)
          this.isLoading = false
        } else {
          let newurl=varurl+this.userid;
          this.openurl(newurl);
        }
},
    goTo(url) {
      //alert(url);
      return this.$router.push(url);
    },
    openurl(url) {
      // let newurl="http://localhost:8081/#/ExtraAuth" +url;
      // eslint-disable-next-line no-unused-vars

      let newurl = url;
      window.location.href = newurl;
      this.isLoading = false
    },
  },
};
</script>

<style scoped>
.linkdiv {
  cursor: pointer;
}
</style>
